class Dropdown {
  constructor() {}

  // TODO: add possibility for custom dropdown classes as parameter string
  setup() {
    if(typeof viewDropdown === "undefined") { // Check that old is removed
      document.addEventListener("DOMContentLoaded", (e) => {
        this.addDropdowns(".vrtx-dropdown-wrapper");

        this.setupCloseDropdownListeners();
        this.dropdownForms();
      });
    }
  }

  addDropdowns(selector) {
    const dropdownWrappers = document.querySelectorAll(selector);
    if(!dropdownWrappers.length) return;

    const dropdown = this;
    dropdownWrappers.forEach(wrp => {
      const link = wrp.previousElementSibling;
      const idWrp = this.addMissingId(wrp, "vrtx-dropdown-wrapper-");
      const idLink = this.addMissingId(link, "vrtx-dropdown-link-");
      wrp.setAttribute("aria-labelledby", idLink);
      link.setAttribute("aria-controls", idWrp);
      link.setAttribute("aria-haspopup", "true");
      this.ariaDropdownState(link, wrp, false, false);

      link.addEventListener("click", function(e) {
        dropdown.toggledOpenClosable(this, dropdown, e);
      });
      const closeLink = wrp.querySelector("a.vrtx-dropdown-close-link");
      if(closeLink) {
        closeLink.addEventListener("click", function(e) {
          dropdown.toggledOpenClosable(this, dropdown, e);
        });
      }
    });
  }

  setupCloseDropdownListeners() {
    // Close on click outside or Escape key
    document.addEventListener("click", (e) => {
      if (!e.target.closest(".vrtx-dropdown-component")) {
        document.querySelectorAll(".vrtx-dropdown-wrapper").forEach(elm => {
          this.hide(elm);
        });
      }
    });
    document.addEventListener("keydown", (e) => {
      if(e.key == "Escape") {
        document.querySelectorAll(".vrtx-dropdown-wrapper").forEach(elm => {
          this.hide(elm);
        });
      }
    });
  }

  dropdownForms() {
    document.querySelectorAll(".vrtx-dropdown-form").forEach(wrp => {
      wrp.classList.add("hidden");
      const dropdownFormLink = wrp.querySelector(".vrtx-dropdown-form-link");
      if(dropdownFormLink) {
        dropdownFormLink.classList.add("visible");
      }

      wrp.parentElement.querySelector(".vrtx-dropdown-form-link").addEventListener("click", function(e) {
        this.previousElementSibling.submit();
        e.stopPropagation();
        e.preventDefault();
      });
    });
  }

  ariaDropdownState(link, wrp, isExpanded, isEnter) {
    if(isExpanded) {
      const firstInteractiveElem = wrp.querySelectorAll("a, input[type='button'], input[type='submit'], button");
      if(firstInteractiveElem.length && isEnter) {
        firstInteractiveElem[0].focus();
      }
    }
    wrp.setAttribute("aria-hidden", !isExpanded);
    link.setAttribute("aria-expanded", isExpanded);
  }

  toggledOpenClosable(link, dropdown, e) {
    const isEnter = e.key === "Enter";
    if(e.type === "click" || isEnter) {
      const container = link.parentElement;
      if(container.classList.contains("vrtx-dropdown-component-toggled")) {
        link.classList.toggle("active");
      }
      if(link.classList.contains("vrtx-dropdown-close-link")) {
        var wrp = link.closest(".vrtx-dropdown-wrapper");
      } else {
        var wrp = link.nextElementSibling;
      }
      if(!container.classList.contains("vrtx-dropdown-component-toggle")) {
        dropdown.toggleShowHide(wrp);
        dropdown.ariaDropdownState(link, wrp, link.classList.contains("active"), isEnter);
      } else {
        wrp.classList.toggle("activated");
        dropdown.ariaDropdownState(link, wrp, link.classList.contains("active"), isEnter);
      }
      e.stopPropagation();
      e.preventDefault();
    }
  }

  toggleShowHide(wrp) {
    if(!wrp.classList.contains("open")) {
      wrp.classList.add("open");
    } else {
      wrp.classList.remove("open");
    }
  }

  hide(wrp) {
    wrp.classList.remove("open");
  }

  addMissingId(elm, classPrefix) {
    if(elm.id) return elm.id;

    const id = classPrefix + Math.round((+new Date() + 1) * Math.random());
    elm.setAttribute("id", id);
    return id;
  }
}

export default new Dropdown;